angular.module('identity').factory('User', function (tgResource) {
	var UserResource = tgResource('User', 'user')

	UserResource.prototype.isAdmin = function () {
		return this.role && this.role == 'Admin'
	}

	UserResource.prototype.isOwner = function () {
		return this.role && this.role == 'Owner'
	}

	UserResource.prototype.isManager = function () {
		return this.role && this.role == 'Manager'
	}

	UserResource.prototype.isOperator = function () {
		return this.role && this.role == 'Operator'
	}

	UserResource.prototype.isViewer = function () {
		return this.role && this.role == 'Viewer'
	}

	UserResource.prototype.isMember = function () {
		return this.role && this.role == 'Member'
	}

	return UserResource
})
